"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
// import LanguageSwitcher from "./LanguageSwitcher";
var antd_1 = require("antd");
var context_1 = require("App/context");
var UserMenu_1 = __importDefault(require("./UserMenu"));
var TenantSwitcher_1 = __importDefault(require("./TenantSwitcher"));
var Logo_1 = __importDefault(require("../../../components/Logo"));
var icons_1 = require("@ant-design/icons");
var TopBar = function () {
    var ctx = react_1.useContext(context_1.ApplicationContext);
    var showCollapseTrigger = function () {
        if (ctx.viewPort === context_1.EViewPort.mobile) {
            if (ctx.navigationCollapsed) {
                return react_1.default.createElement(icons_1.MenuUnfoldOutlined, { className: 'trigger', onClick: ctx.toggleNavigationCollapsed });
            }
            else {
                return react_1.default.createElement(icons_1.MenuFoldOutlined, { className: 'trigger', onClick: ctx.toggleNavigationCollapsed });
            }
        }
        return null;
    };
    var showTenantSwitch = function () {
        return ctx.showTenantSwitch ? react_1.default.createElement(TenantSwitcher_1.default, null) : null;
    };
    return (react_1.default.createElement(antd_1.Row, { align: "middle", justify: "end", gutter: [16, 16] },
        react_1.default.createElement(antd_1.Col, { className: "TriggerAndLogo", lg: 16, md: 10, xs: 8 },
            showCollapseTrigger(),
            react_1.default.createElement(Logo_1.default, null)),
        react_1.default.createElement(antd_1.Col, { lg: 8, md: 14, xs: 16, style: { textAlign: 'end' }, className: "userOptions" },
            showTenantSwitch(),
            " ",
            react_1.default.createElement(UserMenu_1.default, null))));
};
exports.default = TopBar;
//# sourceMappingURL=index.js.map